import React from 'react';
import ReactModal from 'react-modal';
import classNames from 'classnames';
import styles from './styles.module.scss';
import _ from 'lodash';

const overlay = {
  zIndex: 50
};

const content = {
  top: '40%',
  left: '50%',
  maxHeight: '50%',
  right: 'auto',
  bottom: 'auto',
  marginRight: '-25%',
  transform: 'translate(-50%, -50%)',
  width: '50%'
};

export const ModalComponent = ({ title, isOpen, children, notifyOfClose, customStyles = {} }) => {
  const modalStyles = {
    ...{ overlay: { ...overlay, ..._.get(customStyles, 'overlay', {}) } },
    ...{ content: { ...content, ..._.get(customStyles, 'content', {}) } }
  };

  return (
    <ReactModal ariaHideApp={false} style={modalStyles} isOpen={isOpen} onRequestClose={notifyOfClose}>
      <div className={classNames(styles.livModalContent)}>
        <div className={classNames(styles.livModalHeader)}>
          <h5>{title}</h5>
          <h5 className={classNames(styles.close)} onClick={notifyOfClose}>
            &times;
          </h5>
        </div>
        <div className={classNames(styles.livModalBody)}>{children}</div>
      </div>
    </ReactModal>
  );
};
